import { memo } from 'react';
import ReactQuill, { Quill }  from 'react-quill-new';
import { useFormikContext } from 'formik';
import { useDebouncedCallback } from 'use-debounce';
import 'quill/dist/quill.snow.css';
import './HTMLEditor.styles.css';

type Props = { name: string; id?: string; size?: 'small' | 'normal' | 'large'; readOnly: boolean };
const origGetSemanticHTML = Quill.prototype.getSemanticHTML
Quill.prototype.getSemanticHTML = function (...args: unknown[]) {
    return (
        origGetSemanticHTML
            .apply(this, args as [])
            .replace(/&nbsp;/g, " ")
            .replace(/\u00A0/g, " ")
            .replace(/<p(\s[^>]*)?>\s*<\/p>/g, "<p$1><br></p>")
    )
}

function HTMLEditor({ name, id, readOnly = false, size }: Props) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { values, setFieldValue, setFieldTouched } = useFormikContext<any>();
  const value = values[name] || '';
  const debouncedSetFieldValue = useDebouncedCallback((val: string) => {
    setFieldValue(name, val, true);
  }, 0);

  return (
    <div className={`quill-editor-container ${size}`}>
      <ReactQuill
        id={id || name}
        theme="snow"
        value={value}
        onChange={debouncedSetFieldValue}
        onBlur={() => setFieldTouched(name, true, true)}
        readOnly={readOnly}
      />
    </div>
  );
}

export default memo(HTMLEditor);
